import React, { Component } from 'react';
import styles from './styles';
import { css } from 'aphrodite';

class Input extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isError: props.isError
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.isError !== this.props.isError) {
            this.setState({isError: this.props.isError});
        }
    }

    checkIfNumeric(e) {
        // console.log(this.regex(e.target.value))
        if(!e.target.hasOwnProperty("oldValue")) e.target.oldValue = "";
        if(this.regex(e.target.value)) {
            e.target.oldValue = e.target.value;
            e.target.oldSelectionStart = e.target.selectionStart;
            e.target.oldSelectionEnd = e.target.selectionEnd;
            if(e.type === "change") this.props.onChange(e);
        } else if (this.hasOwnProperty("oldValue")) {
            e.target.value = e.target.oldValue;
            e.target.setSelectionRange(e.target.oldSelectionStart, e.target.oldSelectionEnd);
            if(e.type === "change") this.props.onChange(e);
        }
    }

    regex(value) {
        return /^-?\d*[.\/,]?\d*$/.test(value);
    }

    render() {
        const {
            label,
            isImperialSystem,
            square,
            small,
            operator,
            isActive,
            description,
            id,
            value,
            isPrintable
        } = this.props;

        return (
            <div className={css(styles.inputWrapper, isPrintable && styles.printable)}>
                <div className={css(styles.inputBlock)}>
                    <div className={css(styles.inputOperator, isPrintable && styles.hideForPrint)}>{operator}</div>
                    <div className={css(styles.inputLabel, this.state.isError && isActive && styles.labelError, styles.labelPrintable)}
                             dangerouslySetInnerHTML={{__html: label}}></div>
                    <div className={css(styles.inputContainer)}>
                        <div className={css(styles.inputLabel, this.state.isError && isActive && styles.labelError)}
                             dangerouslySetInnerHTML={{__html: label}}></div>
                        <div className={css(styles.showForPrint)}>{value.toString()}</div>
                        <input
                            id={id}
                            type="text"
                            className={css(styles.inputStyle, this.state.isError && isActive && styles.inputError, isPrintable && styles.inputForPrint)}
                            disabled={!isActive}
                            value={value}
                            onChange={(e)=>{this.checkIfNumeric(e)}}
                            onInput={(e)=>{this.checkIfNumeric(e)}}
                            onKeyDown={(e)=>{this.checkIfNumeric(e)}}
                            onKeyUp={(e)=>{this.checkIfNumeric(e)}}
                            onMouseDown={(e)=>{this.checkIfNumeric(e)}}
                            onMouseUp={(e)=>{this.checkIfNumeric(e)}}
                            onSelect={(e)=>{this.checkIfNumeric(e)}}
                            onContextMenu={(e)=>{this.checkIfNumeric(e)}}
                            onDrop={(e)=>{this.checkIfNumeric(e)}}
                        />
                        {description &&
                            description !== "" &&
                            <div className={css(styles.inputDescription, this.state.isError && isActive && styles.labelError, isPrintable && styles.hideForPrint)}>{description}</div>
                        }
                    </div>
                    <div className={css(styles.inputUnit)}>{isImperialSystem ? (small ? "in" : (square ? "ft²" : "ft")) : (small ? "mm" : (square ? "m²" : "m"))}</div>
                </div>

            </div>
        );
    }
}

Input.defaultProps = {
    square: false,
    isActive: true,
    isPrintable: false
}

export default Input;
